var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hover-loading"},[_c('UiIcon',{staticClass:"ui-icon-spin",attrs:{"name":"loading","color":"#fff","size":"lg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }